import { render } from "./pluginItem.vue?vue&type=template&id=79549548&scoped=true"
import script from "./pluginItem.vue?vue&type=script&lang=js"
export * from "./pluginItem.vue?vue&type=script&lang=js"

import "./pluginItem.vue?vue&type=style&index=0&id=79549548&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79549548"]])

export default __exports__